import { ofType, combineEpics } from "redux-observable";
import { switchMap, mergeMap, catchError, map } from "rxjs/operators";
import experimentResource from "@ane/exp-data/lib/resources/ExperimentResources";
import experimentSearchResource from "@ane/exp-data/lib/resources/ExperimentSearchResource";
import { Observable, of } from "rxjs";
import experimentSearchConstants from "./ExperimentSearchConstants.js";
import ExperimentSearchActions from "./ExperimentSearchActions.js";
import "rxjs-compat";
import { getUrlsForOtherSearchFieldsData } from "./ExperimentSearchUtil.js";
import SearchLogPerformanceActions from "../../Common/logging/SearchLogPerformanceActions.js";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const experimentSearchEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_EXP_SEARCH),
    switchMap((value) => {
      return Observable.concat(
        of(SearchLogPerformanceActions.experimentSearchStart()),
        Observable.fromPromise(experimentResource.getAllExperiments(value.payload)).pipe(
          mergeMap((result) => {
            const data = result.getSuccessData().Results;
            const experiments = data.filter((val) => !val.IsFeatureRollout);
            const expIds = experiments.map((exp) => exp.Id);
            const featureRollouts = data.filter((val) => val.IsFeatureRollout);
            const featureRolloutIds = featureRollouts.map((exp) => exp.Id);
            return Observable.of(
              SearchLogPerformanceActions.experimentSearchMainFunctionality(),
              ExperimentSearchActions.getAllExpsAction(result.getSuccessData()),
              ExperimentSearchActions.updateSelectedValues(value.managementGroup, value.isolationGroup, value.trafficFilters),
              ExperimentSearchActions.fetchScorecardsAction(expIds),
              ExperimentSearchActions.fetchStatusAction(featureRolloutIds),
              SearchLogPerformanceActions.experimentSearchFullLoad()
            );
          }),
          catchError((error) => of(ExperimentSearchActions.getAllExpsAction({ Error: true })))
        )
      );
    })
  );
};
const loadMgmtGroupEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_MGMT_GRP),
    switchMap((value) => {
      const workspaceId = EnvironmentService.getWorkspaceIdOrDefault();
      return Observable.fromPromise(MdsDataplaneResources.getExperimentationGroups(workspaceId)).pipe(
        map((result) => {
          const paths = result.getSuccessData().map((g) => g.Path);
          return ExperimentSearchActions.updateMgmtGroupData(paths);
        }),
        catchError((error) => of(ExperimentSearchActions.updateMgmtGroupData([])))
      );
    })
  );
};
const loadIsolationGroupsEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_ISOLATION_GROUPS),
    switchMap((value) => {
      let { workspaceId, managementGroup } = value.payload;
      workspaceId = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      return Observable.fromPromise(MdsDataplaneResources.getExperimentationGroup(workspaceId, managementGroup)).pipe(
        switchMap((eg) => {
          return Observable.fromPromise(
            MdsDataplaneResources.getConfigWithType({
              workspaceId,
              experimentationGroup: eg,
              section: MasterDataConstants.flightControlSection
            })
          ).pipe(
            map((result) => {
              return ExperimentSearchActions.updateIsolationGroupsData({
                id: managementGroup,
                flightControlData: result
              });
            })
          );
        })
      );
    })
  );
};
const loadOtherSearchFieldsEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_OTHER_SEARCH_FIELDS),
    switchMap((value) => {
      let { workspaceId, managementGroup } = value.payload;
      workspaceId = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      return Observable.fromPromise(MdsDataplaneResources.getExperimentationGroup(workspaceId, managementGroup)).pipe(
        switchMap((eg) => {
          return Observable.fromPromise(
            MdsDataplaneResources.getConfigWithType({
              workspaceId,
              experimentationGroup: eg,
              section: MasterDataConstants.controlTowerExperienceSection
            })
          ).pipe(
            map((result) => {
              return ExperimentSearchActions.updateOtherSearchFieldsData(result, managementGroup, workspaceId);
            })
          );
        })
      );
    })
  );
};
const updateOtherSearchFieldsDataEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.UPDATE_OTHER_SEARCH_FIELDS),
    switchMap((value) => {
      const cte = value.payload;
      const urls = getUrlsForOtherSearchFieldsData(cte.SearchExperience, value.managementGroup, value.workspaceId);
      return Observable.of(...urls.map((url) => ExperimentSearchActions.loadSubMgmtGroupData(url)));
    })
  );
};
const loadSubMgmtGroupsEpic = (action$) => {
  return action$.pipe(
    ofType(experimentSearchConstants.LOAD_SUB_MGMT_GRPS),
    switchMap((value) => {
      return Observable.fromPromise(experimentSearchResource.getSubMgmtGroupData(value.payload)).pipe(
        mergeMap(
          (result) => Observable.of(
            ExperimentSearchActions.updateSubMgmtGrpsData({
              url: value.payload,
              subMgmtGroupData: result
            }),
            ExperimentSearchActions.handleSubMgmtState({})
          )
        )
      );
    })
  );
};
const experimentSearchEpics = combineEpics(
  experimentSearchEpic,
  loadMgmtGroupEpic,
  loadIsolationGroupsEpic,
  loadSubMgmtGroupsEpic,
  updateOtherSearchFieldsDataEpic,
  loadOtherSearchFieldsEpic
);
export {
  experimentSearchEpic,
  experimentSearchEpics,
  loadIsolationGroupsEpic,
  loadMgmtGroupEpic,
  loadOtherSearchFieldsEpic,
  loadSubMgmtGroupsEpic,
  updateOtherSearchFieldsDataEpic
};
//# sourceMappingURL=ExperimentEpics.js.map
